import { configureStore } from '@reduxjs/toolkit';
import { createLogger } from 'redux-logger';
import createReducer from './rootReducer';

const middlewares = [];

if (process.env.NODE_ENV === 'development') {
  middlewares.push(
    createLogger({ collapsed: (getState, action, logEntry) => !logEntry.error })
  );
}

const store = configureStore({
  reducer: createReducer(),
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false,
    }).concat(middlewares),
  devTools: process.env.NODE_ENV === 'development',
});

store.asyncReducers = {};

const hot =
  typeof import.meta !== 'undefined' && import.meta.hot
    ? import.meta.hot
    : typeof module !== 'undefined' && module.hot
      ? module.hot
      : null;

if (process.env.NODE_ENV === 'development' && hot) {
  hot.accept('./rootReducer', () => {
    import('./rootReducer').then(({ default: newRootReducer }) => {
      store.replaceReducer(newRootReducer.createReducer());
    });
  });
}

export const injectReducer = (key, reducer) => {
  if (store.asyncReducers[key]) {
    return false;
  }
  store.asyncReducers[key] = reducer;
  store.replaceReducer(createReducer(store.asyncReducers));
  return store;
};

export default store;
